<template>
  <user-list
    @addUserClick="addUserClick()"
    @editUserClick="editUserClick($event)"
    @deleteUserClick="deleteUserClick($event)"
    @loadData="loadData($event)"
    :users="users"
    :usersLoading="usersLoading"
    :totalUsers="totalCount"
  ></user-list>
</template>

<script>
import UserList from '../../components/UserList.vue';
import { listUsers } from '../../mixins/users.mixins';

export default {
  name: 'list-user-view',
  components: { UserList },
  mixins: [
    listUsers,
  ],
  computed: {
    totalCount() {
      return this.usersListInfo.totalCount;
    },
  },
  methods: {
    addUserClick() {
      this.$router.push('/users/new');
    },
    editUserClick(user) {
      this.$router.push({ name: 'edit-user', params: { editUser: user } });
    },
    async deleteUserClick(user) {
      await this.deleteUser(user);
      await this.listUsers();
    },
    async loadData({
      sort, page, maxPerPage, dynamicSearch,
    }) {
      this.usersSearchObject = {
        page,
        maxPerPage,
        sort,
        dynamicSearch,
      };
      await this.listUsers();
    },
  },
};
</script>
